export function numericCompare(a: number, b: number): number {
    // Defines a total ordering on floats, handling the weird cases

    // Such as NaN
    if (isNaN(a)) return isNaN(b) ? 0 : 1;
    if (isNaN(b)) return -1;

    // +/-Infinity is handled here by avoiding a subtraction
    if (a < b) return -1;
    if (a > b) return 1;

    // Distinguish signed zero
    if (a === 0 && b === 0) {
        const aSgn = Object.is(a, -0) ? -1 : 1;
        const bSgn = Object.is(b, -0) ? -1 : 1;
        return aSgn - bSgn;
    }

    return 0;
}

export function booleanCompare(a: any, b: any): number {
    // Sorts false first, then true, because numerically
    // they map to 0 and 1 respectively
    return Number(!!a) - Number(!!b);
}
